const colors = require('tailwindcss/colors');

export const themeLight = {
  theme: 'light',
  background: 'bg-white',
  logo: 'text-black',
  dropdown: {
    background: 'bg-gray-50',
    shadow: '#F1F5F9',
    backgroundSolutions: 'bg-gray-100',
    backgroundBottomMobile: 'bg-gray-200',
    border: 'border-gray-200',
    title: 'text-gray-600',
    items: {
      icon: 'bg-blue-gray-100',
      title: 'text-black',
      text: 'text-gray-600'
    },
    caret: {
      background: '#f9fafb',
      border: '#F1F5F9'
    }
  },
  closeButton: {
    cross: colors.black,
    background: 'bg-blue-gray-200'
  },
  rapid: {
    background: 'bg-gray-50',
    text: 'text-black',
    gradient: true
  },
  labeled: 'bg-black text-white'
};

export const themeDark = {
  theme: 'dark',
  background: 'bg-gray-900',
  logo: 'text-white',
  dropdown: {
    background: 'bg-gray-900',
    shadow: '#262626',
    backgroundSolutions: 'bg-gray-800',
    backgroundBottomMobile: 'bg-gray-800',
    border: 'border-gray-800',
    title: 'text-gray-400',
    items: {
      icon: 'bg-gray-700',
      title: 'text-white',
      text: 'text-gray-400'
    },
    caret: {
      background: '#171717',
      border: '#262626'
    }
  },
  closeButton: {
    cross: colors.white,
    background: 'bg-gray-600'
  },
  rapid: {
    background: 'bg-gray-900',
    text: 'text-white',
    gradient: true
  },
  labeled: 'bg-white text-black'
};

export default themeLight;
